/* global num_classes:true days_data:true months_data:true */

SC.souljourney = (function () {
  var api = {};

  /**
   * initialization function
   * @returns {void}
   */
  function init() {
    var numClasses = (typeof num_classes !== 'undefined') ? num_classes : 0;

    setUpBarChart(numClasses);
    setUpLineChart(numClasses);
    setEvents();
    setUpOdometer(numClasses);
    copyShareUrl();
    animateFill();
  }

  /**
   * setUpBarChart sets up the bar chart that shows "when you clip in"
   * @param {int} numClasses the current number of classes to show on the bar chart
   * @returns {void}
   */
  function setUpBarChart(numClasses) {
    if (numClasses >= 10) {
      Chart.defaults.global.responsive = true;
      var ctx = $('#bar-chart').get(0).getContext('2d');
      var data = {
        labels: days_data.labels,
        datasets: [
          {
            label: 'when you clip in...',
            fillColor: 'rgba(200,200,200,1)',
            data: days_data.data
          }
        ]
      };
      var options = {
        scaleShowGridLines: false,
        barShowStroke: false,
        barValueSpacing: 3
      };
      // eslint-disable-next-line no-unused-vars
      var myBarChart = new Chart(ctx).Bar(data, options); // eslint-disable-line new-cap
    }
  }

  /**
   * setUpLineCharts sets up the line chart that shows "your year at soul"
   * @param {int} numClasses the current number of classes to show on the bar chart
   * @returns {void}
   */
  function setUpLineChart(numClasses) {
    if (numClasses >= 10) {
      Chart.defaults.global.responsive = true;
      var ctx = $('#line-chart').get(0).getContext('2d');
      var data = {
        labels: months_data.labels,
        datasets: [
          {
            label: 'your year at soul...',
            fillColor: 'rgba(200,200,200,1)',
            pointColor: 'rgba(254,224,0, 1)',
            data: months_data.data
          }
        ]
      };
      var options = {
        scaleShowGridLines: false
      };
      // eslint-disable-next-line no-unused-vars
      var myLineChart = new Chart(ctx).Line(data, options); // eslint-disable-line new-cap
    }
  }

  /**
   * setUpOdomoter sets up the animated number of classes a rider has taken
   * @param {int} numClasses the current number of classes to show on the bar chart
   * @returns {void}
   */
  function setUpOdometer(numClasses) {
    if (numClasses >= 10) {
      var el = document.getElementById('odometer');
      var od = new Odometer({
        el: el,
        value: 0,
        format: '',
        theme: 'default'
      });
      od.update(numClasses);
    }
  }

  /**
   * setEvents sets up the events on buttons
   * @returns {void}
   */
  function setEvents() {
    $('.souljourney__soulsquad-container').on('mouseenter mouseleave', function () {
      $('.souljourney__soulsquad-gray-button').toggleClass('block');
    });

    /**
     * Old GA sendEvent - Click the Share icon, gray button or Spotify CTA
     * Deprecated: Will be removed soon.
     */
    $('.share-icon, .souljourney__soulsquad-gray-button, .souljourney__spotify-cta').on('click', function () {
      SC.analytics.ga.sendEvent($(this).attr('data-analytics-category'), $(this).attr('data-analytics-action'));
    });

    // Show and hide the soulsquad modal
    $('.soulsquad__launch').on('click', function () {
      $('.souljourney__soulsquad').addClass('block');
      window.scrollTo(0, 0);
    });

    $('.soulsquad__close-modal').on('click', function () {
      $('.souljourney__soulsquad').removeClass('block');
    });
  }

  /**
   * copyShareUrl sets up listeners to copy the share/modal share urls
   * @returns {void}
   */
  function copyShareUrl() {
    $('#share-url').on('click', function () {
      copyToClipboardMsg(document.getElementById('share-target'));

      $('.share-icon.share-url').removeClass('not-copied');
      $('.share-icon.share-url').addClass('copy-background');

      setTimeout(function () {
        $('.share-icon.share-url').addClass('not-copied');
        $('.share-icon.share-url').removeClass('copy-background');
      }, 2000);
    });

    $('#modal-share-url').on('click', function () {
      copyToClipboardMsg(document.getElementById('modal-share-target'));

      $('#modal-share-url.share-icon.share-url ').removeClass('not-copied');
      $('#modal-share-url.share-icon.share-url ').addClass('copy-background');

      setTimeout(function () {
        $('#modal-share-url.share-icon.share-url ').addClass('not-copied');
        $('#modal-share-url.share-icon.share-url ').removeClass('copy-background');
      }, 2000);
    });
  }

  /**
   * animateFill animates the yellow fills on the page
   * @returns {void}
   */
  function animateFill() {
    $('.yellow-fill').animate({
      height: (parseInt( $('.yellow-fill').attr('data-fill-percent') * 100, 0)) + '%'
    }, 2000);
  }

  /**
   * mParticle event Tracking - social share - referral link
   */
  $('.share-icons .share-icon').on('click', function () {
    /**
     * mParticle event Tracking - social share - SoulJourney
     */
    var $button = $(this);
    var platform = $button.closest('.share-icon-link').data('platform');
    var shareInfo = $button.closest('.share-icons').data();
    var eventData = {
      'Platform': platform,
      'Location': shareInfo.location,
      'Share Type': shareInfo.shareType
    };

    SC.analytics.mp.sendEvent('Share', 'social', eventData, shareInfo.shareType);
  });

  /**
   * copyToClipboardMsg copies a message to the clipboard and shows a confirmation message
   * @param {obj} elem the element to copy to the clipboard
   * @returns {void}
   */
  function copyToClipboardMsg(elem) {
    var succeed = copyToClipboard(elem);

    if (!succeed) {
      confirmation(undefined, 'Copy not supported or blocked.  Press Ctrl+c to copy.');
    } else {
      confirmation(undefined, 'URL copied!');
    }
  }

  /**
   * copyToClipboard copies an element to the clipboard
   * @param {obj} elem the element to copy to the clipboard
   * @returns {void}
   */
  function copyToClipboard(elem) {
    // create hidden text element, if it doesn't already exist
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionStart;
    var origSelectionEnd;

    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);

      if (!target) {
        var target = document.createElement('textarea');
        target.style.position = 'absolute';
        target.style.left = '-9999px';
        target.style.top = '0';
        target.id = targetId;
        document.body.appendChild(target);
      }

      target.textContent = elem.textContent;
    }

    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);
    // copy the selection
    var succeed;

    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }

    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = '';
    }

    return succeed;
  }

  init();
  return api;
}());
